define('uikit/elements/component.with.help.text',['require','exports','module','./help.text.icon','../mixins/component.mixin','../templates','marionette'],function(require, exports, module) {
  // prettier-ignore
  var HelpTextIcon   = require('./help.text.icon'),
      ComponentMixin = require('../mixins/component.mixin'),
      Templates      = require('../templates'),
      Mn             = require('marionette');

  var ComponentWithHelpText = Mn.ItemView.extend(ComponentMixin).extend({
    template: Templates.UIKit['component.with.info'],
    options: {
      text: '',
      helpText: '',
    },

    internalViewOptions: {
      helpIcon: function() {
        return {
          type: HelpTextIcon,
          helpText: this.getOption('helpText'),
        };
      },
    },
  });

  module.exports = ComponentWithHelpText;
});

